import React from 'react';
import type { PropertyEditor, PropertyEditorProps } from '../../../registry/PropertyEditor.types';

function renderLinkEditor(props: PropertyEditorProps) {
  const { control, onConfigChange } = props;

  return (
    <div className="af-properties-tab__section">
      <h4 className="af-properties-tab__subsection-title">Link Settings</h4>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          URL
          <input
            type="text"
            value={(control.config?.href as string) || ''}
            onChange={(e) => onConfigChange('href', e.target.value || undefined)}
            className="af-properties-tab__input"
            placeholder="https://..."
          />
        </label>
      </div>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Open In
          <select
            value={(control.config?.target as string) || '_self'}
            onChange={(e) => onConfigChange('target', e.target.value)}
            className="af-properties-tab__select"
          >
            <option value="_self">Same Tab</option>
            <option value="_blank">New Tab</option>
          </select>
        </label>
      </div>
    </div>
  );
}

export const LinkEditor: PropertyEditor = {
  type: 'link',
  label: 'Link',
  description: 'Configure link URL and target',
  render: renderLinkEditor,
};
